<div id="company_search_container" class="formfield nes-flex nes-flex-col nes-w-full">
  <label class="company__label nes-w-full nes-text-form-label nes-font-bold nes-font-sans nes-text-left">
    {{ "COMPANY_DATA.INPUT.COMPANY.LABEL" | translate }}
  </label>
  <div class="formfield__inputContainer nes-w-full nes-ml-0 nes-pl-0">
    <div class="kvk-input-wrapper">
      <nes-icon name="search" class="kvk-search-icon"></nes-icon>
      <ns-type-ahead
      suggestIcon="autosuggest__link--poi"
      (suggestionSelected)="onSelectedCompany($event)"
      (focus)="onFocus()"
      (focusout)="onFocusOut()"
      [autoFocus]="selectedCompany == null"
      [placeholder]="'COMPANY_DATA.INPUT.COMPANY.PLACEHOLDER' | translate"
      [searchControl]="searchControl"
      [searchFn]="searchFn"
      [privacySensitive]="true"
    >
    </ns-type-ahead>
    </div>

    @if (companyRequiredError) {
      <nes-error-message>
        {{ companyRequiredError }}
      </nes-error-message>
    }

    <div *ngIf="companyLoading" class="basicLoader"></div>
  </div>
</div>

<div *ngIf="companyFetching; else company" class="basicLoader"></div>

<ng-template #company>
  <ng-container *ngIf="selectedCompany">
    <div class="formfield nes-flex nes-flex-col nes-w-full">
      <div class="formfield__inputContainer nes-w-full nes-ml-0 nes-pl-0">
        <div class="company__tile animated pulse" [cypress]="'company_result'">
          <a
            [cypress]="'company_close'"
            class="closeButton"
            (click)="closeCompany()"
          >
            <i class="icon"></i>
          </a>
          <div class="company__data-box" privacySensitive>
            <div class="company__name">{{ selectedCompany.name }}</div>
            <div class="company__detail">{{ "KVK" | translate }}: {{ selectedCompany.kvkNumber }}</div>
            <ng-container *ngIf="selectedCompany.address as address">
              <div class="company__detail">
                {{ address.street }} {{ address.houseNumber }}
                {{ address.addition }}
              </div>
              <div class="company__detail">{{ address.postcode }} {{ address.city }}</div>
            </ng-container>
          </div>
          <p class="address-info-line">
            <i class="icon attention-thick"></i>
            {{ 'COMPANY_DATA.SEARCH_RESULT.ADDRESS_INFO' | translate }}
          </p>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
